import { APIRequestBase } from '@/models/api/models-api'

/**
 * Web-連携一意キー発行APIリクエストクラス
 * @class PostCardAlignmentSetupRequest
 */
export class PostCardAlignmentSetupRequest extends APIRequestBase {
    /**
     * @constructor
     */
    constructor(_provisionShopCode, _cardNumber, _brandsite) {
        super()

        this.provisionShopCode = _provisionShopCode
        this.cardNumber = _cardNumber
    }

    /** @type {string} */
    provisionShopCode = null
    /** @type {string} */
    cardNumber = null
}
